import { useCallback, useState } from 'react';

import update from 'immutability-helper';

import { GenericObject } from '@app/components/common/Table/DefaultTable/types';

export const useOrderable = () => {
  const [selected, setSelected] = useState<GenericObject[]>([]);

  const handleChangeSelected = (newSelected: GenericObject[]) => {
    setSelected(newSelected);
  };

  const moveCard = useCallback((dragIndex: number, hoverIndex: number) => {
    setSelected((prevCards) =>
      update(prevCards, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, prevCards[dragIndex]],
        ],
      })
    );
  }, []);

  return { selected, handleChangeSelected, moveCard };
};
